var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1501_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2498 17.1091C14.9237 17.1091 17.902 14.1308 17.902 10.4569C17.902 6.78301 14.9237 3.80473 11.2498 3.80473C7.57591 3.80473 4.59763 6.78301 4.59763 10.4569C4.59763 14.1308 7.57591 17.1091 11.2498 17.1091Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11C2 8.6131 2.9482 6.3239 4.636 4.636C6.3239 2.9482 8.6131 2 11 2C13.3869 2 15.6761 2.9482 17.364 4.636C19.0518 6.3239 20 8.6131 20 11C20 13.3869 19.0518 15.6761 17.364 17.364C15.6761 19.0518 13.3869 20 11 20C8.6131 20 6.3239 19.0518 4.636 17.364C2.9482 15.6761 2 13.3869 2 11ZM10.4864 14.852L15.668 8.3744L14.732 7.6256L10.3136 13.1468L7.184 10.5392L6.416 11.4608L10.4864 14.8532V14.852Z",
    fill: "#C19444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9289 3.9289C2.2908 5.5671 1.2797 7.7151 1.0501 10H1V11C1 13.6522 2.0536 16.1957 3.9289 18.0711C5.8043 19.9464 8.3478 21 11 21C13.6522 21 16.1957 19.9464 18.0711 18.0711C19.9464 16.1957 21 13.6522 21 11C21 8.3478 19.9464 5.8043 18.0711 3.9289C16.1957 2.0536 13.6522 1 11 1C8.3478 1 5.8043 2.0536 3.9289 3.9289Z",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1501_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusCheck);
export default __webpack_public_path__ + "static/media/status-check.d812567cbf0ecac72257c89183368cfc.svg";
export { ForwardRef as ReactComponent };